import { useCallback, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Per-user "Got it" tracking, stored on the account so hints don't reappear on other devices.
export function useHint(key) {
  const { user, setUser } = useAuth();
  const dismissed = !!user?.dismissed_hints?.includes(key);
  const sent = useRef(new Set());

  const dismiss = useCallback(() => {
    if (sent.current.has(key) || user?.dismissed_hints?.includes(key)) return;
    sent.current.add(key);
    setUser((u) => (u ? { ...u, dismissed_hints: [...(u.dismissed_hints || []), key] } : u));
    api.post("/me/hints", { key }).catch(() => { sent.current.delete(key); });
  }, [key, user, setUser]);

  return { dismissed, dismiss };
}
